interface SystemSettings {
  [key: string]: string | number | boolean
}

export function useSystemSettings() {
  // Get settings that were loaded by plugin
  const systemSettings = useState<SystemSettings>('system-settings', () => ({}))

  return {
    systemSettings: readonly(systemSettings)
  }
}
